<template>
    <a-layout id="golden-alpha-otc" :class="{'dialog': mobileMenuOpen, show_landing: disableScroll}">
        <TopNavigation v-if="!privateSection && !show_landing" />
        <a-alert
            v-if="isUat"
            :message="i18n('global.alert.staging_alert_desc')"
            type="error"
            banner 
        />
        <RiskReminderBanner v-if="!show_landing" :no-bottom-margin="depositStackedBelowRisk" />
        <DepositPendingBanner v-if="!show_landing" :stacked-below-risk="depositStackedBelowRisk" />
        <a-layout class="golden-alpha-otc-body" :class="{ 'user-dash': privateSection, show_landing}">
            <a-layout-sider v-if="userInfo && privateSection" class="otc-nav" :class="{home:isHome}" @collapse="onCollape" width="300px">
                <SideNavigation :collapsed="collapsed" :class="{home:isHome}" />
            </a-layout-sider>
            <a-layout-content class="site-body" :class="{private:privateSection}">
                 
                <DashboardTopNavigation />
                <router-view />
                <a-alert
                    v-if="isUat"
                    :message="i18n('global.alert.staging_alert_msg')"
                    :description="i18n('global.alert.staging_alert_desc')"
                    type="error"
                    banner 
                />
                <Footer></Footer>
            </a-layout-content>
        </a-layout>
        <a-alert
            v-if="isUat"
            :message="i18n('global.alert.staging_alert_desc')"
            type="error"
            banner 
        />
        <EmailVerifyModal
            :visible="showEmailVerifyModal"
            @success="onEmailVerifySuccess"
        />
        <!-- Zp 渠道登录：全局居中转圈 loading -->
        <Transition name="fade-landing" appear>
            <div class="zp-auth-loading" v-show="zpAuthLoading">
                <a-spin size="large" />
            </div>
        </Transition>
        <Transition name="fade-landing" appear>
            <div class="loading-frame" v-show="show_landing">
                <div class="logo" >
                        <div class="logo-left">
                            <Transition name="slide-up-landing" appear>
                                <span v-if="show_landing"><img :src="whiteLogoHref" />OTC</span>
                            </Transition>
                        </div>
                        <div class="logo-right">
                            <Transition name="slide-down-landing" appear>
                                <span v-if="show_landing">Pro</span>
                            </Transition>
                        </div>
                </div>
            </div>
        </Transition>
    </a-layout>
</template>

<script setup lang="ts">
import { message, notification } from 'ant-design-vue';
import { h, ref, onMounted, nextTick, computed, reactive, toRefs, toRef, defineComponent, watch } from "vue";
import { useStore } from "./store" ;
import { useRoute, useRouter } from "vue-router";
import { useI18n } from 'vue-i18n'
import { io } from "socket.io-client";
import moment from 'moment';
import { gtagEvent } from './components/common';
import logger from './utils/logger';
import EmailVerifyModal from './components/Global/EmailVerifyModal.vue';
import RiskReminderBanner from './components/Global/RiskReminderBanner.vue';
import DepositPendingBanner from './components/Global/DepositPendingBanner.vue';

const route = useRoute();
const store = useStore();
const { t:i18n } = useI18n();
const accessToken = computed(() => store.getters.accessToken );
const notificationEnabled = ref<Boolean>(false);
const collapsed = ref<Boolean>(false);
const trigger = ref<String|null>('>');
const router = useRouter();
const show_landing = ref<Boolean>(false);
const disableScroll = ref<Boolean>(false);
const publicUrls = [
    `/`, `/session-expired`, `/privacy`, `/term_of_use`, `/contact_us`, `/about_us`, `/faqs`, `/signin`, `/signup`, `/forgotpassword`, `/features`, `/reset-password`, `/activate-account`, `/403`, `/404`, `/500`
];
const privateUrls = [
    '/dashboard'
];
const userInfo = computed(() => store.getters.userInfo );
const domain = computed(() => store.getters.domain );
const mobileMenuOpen = computed(() => store.getters.mobileMenuOpen );
const zpAuthLoading = computed(() => store.getters.zpAuthLoading);
const last_access_str = computed(() => store.getters.last_access_str);
const showDepositPendingBanner = computed(() => {
    return !!accessToken.value
        && store.getters.hasPendingDepositDetails
        && !store.getters.pendingDepositLoading;
});
const riskReminderVisible = computed(() => {
    if (typeof window === 'undefined') return true;
    return window.localStorage.getItem('RISK_REMINDER_BANNER_DISMISSED') !== '1';
});
const depositStackedBelowRisk = computed(() => showDepositPendingBanner.value && riskReminderVisible.value);
/** 已登录且（邮箱为空或以 @login.local1 结尾）时显示邮箱验证弹窗（不可通过点击遮罩关闭） */
const showEmailVerifyModal = computed(() => {
    const info = store.getters.userInfo;
    const token = store.getters.accessToken;
    if (!token || !info) return false;
    const email = String(info.email || '').trim();
    const needBind = !email || email.toLowerCase().endsWith('@login.local1');
    return needBind;
});

interface OrderResultInfo {
    exchange_guid: String | null,
    instrument: String,
    deal_quantity: Number,
    deal_price: Number,
    order_type: String,
    side: String,
    status: Number,
    user_guid: String,
    accept_slippage_bps: Number,
    msg: String,
}
interface OrderResult {
    result: OrderResultInfo,
}
const isUat = computed(() => {
    return import.meta.env.MODE !== 'production'
});
const whiteLogoHref = computed(() => {
    return new URL("./assets/otcpro_logo_white.png", import.meta.url).href;
})

const privateSection = computed(() => {
    return route.path.startsWith(`/dashboard`)
    // || route.path.startsWith(`/session-expired`)
    // || route.path.startsWith(`/404`);
});
const publicSection = computed(() => {
    return route.path.startsWith(`/dashboard`)
    || route.path.startsWith(`/session-expired`)
    || route.path.startsWith(`/404`);
});
/** 有 token 时拉取 userInfo，保证首屏菜单等依赖用户信息的 UI 正确显示 */
async function ensureUserInfoWhenHasToken() {
    const token = store.state.accessToken;
    if (!token || token === 'null' || token === 'undefined') return;
    if (store.state.userInfo) return;
    const timeout = new Promise<void>(r => setTimeout(r, 3000));
    try {
        await Promise.race([store.dispatch('getUserInfo'), timeout]);
    } catch (_) {}
}

async function onEmailVerifySuccess() {
    store.commit('setZpSource', null);
    await store.dispatch('getUserInfo');
    await store.dispatch('fetchPendingDepositDetails');
}

watch(accessToken, (token) => {
    if (token) {
        store.dispatch('fetchPendingDepositDetails');
    } else {
        store.dispatch('clearPendingDepositDetails');
    }
}, { immediate: true });

onMounted(async () => {
    store.dispatch('init');
    await nextTick();
    await store.dispatch('checkUnionIdAndClearIfMismatch');
    await ensureUserInfoWhenHasToken();

    if(last_access_str.value == null) {
        store.dispatch('setLastAccess');
        runLanding();
    }
    else {
        const diff = moment().diff(moment(last_access_str.value), "hour");
        if(diff > 1) {
            runLanding();
        }
        store.dispatch('setLastAccess');
    }

    if(router.currentRoute.value.query && router.currentRoute.value.query.pid) {

        gtagEvent({
            name: "Access via Partner",
            event_category: "PARTNER_REFERENCE", 
            event_label: router.currentRoute.value.query.pid.toString(),
        });
    }

    if(route.query && route.query.referral && route.query.referral.length > 0) {
        logger.log(route.query.referral.toString());
        localStorage.setItem("REFERRAL_CODE", route.query.referral.toString());
    }

    logger.log(router.currentRoute.value.query);

    setTimeout(() => {
        if(!accessToken.value && privateSection.value) {
            router.replace({ path: `/session-expired` }); 
        }
    }, 500);
});

const runLanding = () => {
    
    disableScroll.value = true

    show_landing.value = true;

    setTimeout(() => {
        show_landing.value = false;
    }, 3300);

    setTimeout(() => {
        disableScroll.value = false
    }, 4000);
}

const isHome = computed(() => {
    if(publicUrls.includes(route.path)) {
        
        collapsed.value = false;
        
        trigger.value = null;
        return true;
    }
    return false;
});

const onCollape = (isCollapsed: Boolean) => {
    collapsed.value = isCollapsed;
}
</script>

<style lang="less">
:root {
    /* 设计字体 Token：Primary Body / Secondary / Number；匹配不到默认 Primary Body */
    --font-primary-body: "RedHatRegular", "Red Hat Display", sans-serif;
    --font-secondary: "Montserrat", "RedHatRegular", "Red Hat Display", sans-serif;
    --font-number: "RedHatMono", "RedHatMonoRegular", "Red Hat Mono", "RedHatRegular", monospace;
}

.font-primary-body {
    font-family: var(--font-primary-body);
}
.font-secondary {
    font-family: var(--font-secondary);
}
.font-number {
    font-family: var(--font-number);
}

@font-face {
    font-family: 'RedHatRegular';
    src: local('Red Hat Regular'), url(./assets/fonts/RedHatDisplay-Medium.ttf) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatRegular';
    src:local('Red Hat Regular'), url(./assets/fonts/RedHatDisplay-Regular.ttf) format('truetype');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatRegular';
    src:local('Red Hat Regular'), url(./assets/fonts/RedHatDisplay-Italic.ttf) format('truetype');
    font-weight: 400;
    font-style: italic;
}
@font-face {
    font-family: 'RedHatRegular';
    src:local('Red Hat Regular'), url(./assets/fonts/RedHatDisplay-Medium.ttf) format('truetype');
    font-weight: 500;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatRegular';
    src:local('Red Hat Regular'), url(./assets/fonts/RedHatDisplay-MediumItalic.ttf) format('truetype');
    font-weight: 500;
    font-style: italic;
}
@font-face {
    font-family: 'RedHatRegular';
    src:local('Red Hat Regular'), url(./assets/fonts/RedHatDisplay-SemiBold.ttf) format('truetype');
    font-weight: 600;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatRegular';
    src:local('Red Hat Regular'), url(./assets/fonts/RedHatDisplay-Bold.ttf) format('truetype');
    font-weight: 700;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatRegular';
    src:local('Red Hat Regular'), url(./assets/fonts/RedHatDisplay-BoldItalic.ttf) format('truetype');
    font-weight: 700;
    font-style: italic;
}
@font-face {
    font-family: 'RedHatRegular';
    src:local('Red Hat Regular'), url(./assets/fonts/RedHatDisplay-ExtraBold.ttf) format('truetype');
    font-weight: 800;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatRegular';
    src:local('Red Hat Regular'), url(./assets/fonts/RedHatDisplay-Black.ttf) format('truetype');
    font-weight: 900;
    font-style: normal;
}

@font-face {
    font-family: 'RedHatRegular';
    src:local('Red Hat Regular'), local('Red Hat Regular'), url(./assets/fonts/RedHatDisplay-Bold.ttf) format('truetype');
    font-weight: bold;
    font-style: normal;
}

/* Secondary: Montserrat */
@font-face {
    font-family: 'Montserrat';
    src: url(./assets/fonts/Montserrat-Regular.ttf) format('truetype');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'Montserrat';
    src: url(./assets/fonts/Montserrat-Italic.ttf) format('truetype');
    font-weight: 400;
    font-style: italic;
}
@font-face {
    font-family: 'Montserrat';
    src: url(./assets/fonts/Montserrat-Medium.ttf) format('truetype');
    font-weight: 500;
    font-style: normal;
}
@font-face {
    font-family: 'Montserrat';
    src: url(./assets/fonts/Montserrat-MediumItalic.ttf) format('truetype');
    font-weight: 500;
    font-style: italic;
}
@font-face {
    font-family: 'Montserrat';
    src: url(./assets/fonts/Montserrat-SemiBold.ttf) format('truetype');
    font-weight: 600;
    font-style: normal;
}
@font-face {
    font-family: 'Montserrat';
    src: url(./assets/fonts/Montserrat-Bold.ttf) format('truetype');
    font-weight: 700;
    font-style: normal;
}

/* Number: Red Hat Mono */
@font-face {
    font-family: 'RedHatMono';
    src: url(./assets/fonts/RedHatMono-Regular.ttf) format('truetype');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatMono';
    src: url(./assets/fonts/RedHatMono-Italic.ttf) format('truetype');
    font-weight: 400;
    font-style: italic;
}
@font-face {
    font-family: 'RedHatMono';
    src: url(./assets/fonts/RedHatMono-Medium.ttf) format('truetype');
    font-weight: 500;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatMono';
    src: url(./assets/fonts/RedHatMono-MediumItalic.ttf) format('truetype');
    font-weight: 500;
    font-style: italic;
}
@font-face {
    font-family: 'RedHatMono';
    src: url(./assets/fonts/RedHatMono-SemiBold.ttf) format('truetype');
    font-weight: 600;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatMono';
    src: url(./assets/fonts/RedHatMono-Bold.ttf) format('truetype');
    font-weight: 700;
    font-style: normal;
}
/* 兼容旧名 RedHatMonoRegular */
@font-face {
    font-family: 'RedHatMonoRegular';
    src: url(./assets/fonts/RedHatMono-Regular.ttf) format('truetype');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatMonoRegular';
    src: url(./assets/fonts/RedHatMono-Medium.ttf) format('truetype');
    font-weight: 500;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatMonoRegular';
    src: url(./assets/fonts/RedHatMono-SemiBold.ttf) format('truetype');
    font-weight: 600;
    font-style: normal;
}
@font-face {
    font-family: 'RedHatMonoRegular';
    src: url(./assets/fonts/RedHatMono-Bold.ttf) format('truetype');
    font-weight: 700;
    font-style: normal;
}
/* Zp 渠道登录：全局居中转圈 */
.zp-auth-loading {
    position: fixed;
    inset: 0;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.75);
}
.loading-frame {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100vh;
    background-color: #FFF;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    overflow: hidden;
    user-select: none;
    .logo {
        display: flex;
        color: #FFC100;
        font-size: 100px;
        width: 100%;
        height: 100%;
        font-weight: bold;
        color: #FFF;
        background-color: #FFC100;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(280,1280,635)'%3E%3Cstop offset='0' stop-color='%23FFC100'/%3E%3Cstop offset='1' stop-color='%23FFA400'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='1553' height='1294.2' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.025'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
        background-attachment: fixed;
        background-size: cover;
        & > div {
            display: flex;
            align-items: center;
            img {
                width: 140px;
            }
            &.logo-left {
                width: calc(50% + 70px);
                justify-content: flex-end;
            }
            &.logo-right {
                width: calc(50% - 70px);
            }
            span {
                display: flex;
                align-items: center;
            }
        }
        @media screen and (max-width: 910px) {
            font-size: 80px;
            & > div {
                img {
                    width: 120px;
                }
                &.logo-left {
                    width: calc(50% + 60px);
                    justify-content: flex-end;
                    
                }
                &.logo-right {
                    width: calc(50% - 60px);
                }
            }
        }
        @media screen and (max-width: 600px) {
            font-size: 70px;
            & > div {
                img {
                    width: 100px;
                }
                &.logo-left {
                    width: calc(50% + 50px);
                    justify-content: flex-end;
                }
                &.logo-right {
                    width: calc(50% - 50px);
                }
            }
        }
        @media screen and (max-width: 415px) {
            font-size: 60px;
            font-weight: 500;
            & > div {
                img {
                    width: 80px;
                }
                &.logo-left {
                    width: calc(50% + 40px);
                    justify-content: flex-end;
                }
                &.logo-right {
                    width: calc(50% - 40px);
                }
            }
        }
    }
}
.otc-nav {
    z-index: 999;
    @media screen and (max-width: 910px) {
        display: none;
    }
    &.home {
        display: none;
    }
}
.ant-drawer-content-wrapper {
    @media screen and (max-width: 910px) {
        width: 100% !important;
    }
}

.otc-header {
    background-color: #010101;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 1000'%3E%3Cg %3E%3Ccircle fill='%23010101' cx='50' cy='0' r='50'/%3E%3Cg fill='%23030303' %3E%3Ccircle cx='0' cy='50' r='50'/%3E%3Ccircle cx='100' cy='50' r='50'/%3E%3C/g%3E%3Ccircle fill='%23040404' cx='50' cy='100' r='50'/%3E%3Cg fill='%23060606' %3E%3Ccircle cx='0' cy='150' r='50'/%3E%3Ccircle cx='100' cy='150' r='50'/%3E%3C/g%3E%3Ccircle fill='%23080808' cx='50' cy='200' r='50'/%3E%3Cg fill='%230a0a0a' %3E%3Ccircle cx='0' cy='250' r='50'/%3E%3Ccircle cx='100' cy='250' r='50'/%3E%3C/g%3E%3Ccircle fill='%230b0b0b' cx='50' cy='300' r='50'/%3E%3Cg fill='%230d0d0d' %3E%3Ccircle cx='0' cy='350' r='50'/%3E%3Ccircle cx='100' cy='350' r='50'/%3E%3C/g%3E%3Ccircle fill='%230f0f0f' cx='50' cy='400' r='50'/%3E%3Cg fill='%23101010' %3E%3Ccircle cx='0' cy='450' r='50'/%3E%3Ccircle cx='100' cy='450' r='50'/%3E%3C/g%3E%3Ccircle fill='%23121212' cx='50' cy='500' r='50'/%3E%3Cg fill='%23141414' %3E%3Ccircle cx='0' cy='550' r='50'/%3E%3Ccircle cx='100' cy='550' r='50'/%3E%3C/g%3E%3Ccircle fill='%23151515' cx='50' cy='600' r='50'/%3E%3Cg fill='%23171717' %3E%3Ccircle cx='0' cy='650' r='50'/%3E%3Ccircle cx='100' cy='650' r='50'/%3E%3C/g%3E%3Ccircle fill='%23191919' cx='50' cy='700' r='50'/%3E%3Cg fill='%231b1b1b' %3E%3Ccircle cx='0' cy='750' r='50'/%3E%3Ccircle cx='100' cy='750' r='50'/%3E%3C/g%3E%3Ccircle fill='%231c1c1c' cx='50' cy='800' r='50'/%3E%3Cg fill='%231e1e1e' %3E%3Ccircle cx='0' cy='850' r='50'/%3E%3Ccircle cx='100' cy='850' r='50'/%3E%3C/g%3E%3Ccircle fill='%23202020' cx='50' cy='900' r='50'/%3E%3Cg fill='%23212121' %3E%3Ccircle cx='0' cy='950' r='50'/%3E%3Ccircle cx='100' cy='950' r='50'/%3E%3C/g%3E%3Ccircle fill='%23232323' cx='50' cy='1000' r='50'/%3E%3C/g%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: contain;
    color: #FFF;
    flex-wrap: nowrap;
    padding: 1em;
    font-size: 48px;
    display: flex;
    align-content: flex-start;
    justify-content: flex-end;
    min-height: 100vh;
}
html {
    scroll-behavior: smooth;
    font-family: var(--font-primary-body);
    font-weight: 500;
}
body {
    scroll-behavior: smooth;
    font-family: var(--font-primary-body);
    font-weight: 500;
}
.ant-notification {
    z-index: 99999;
}
.ant-spin-dot {
    margin: 16px;
    text-align: center;
}
#app {
    background-attachment: fixed;
    background-size: cover;
    font-family: var(--font-primary-body);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    width: 100%;
    @media screen and (max-width: 650px) {
        width: 100%;
        max-width: 100vw;
        overflow-x: hidden;
    }
    .site-body {
        position: relative;
        width: 100%;
        &.private {
            padding-top: 114px;
            padding-left: 300px;
            @media screen and (max-width: 910px) {
                padding-left: 0px;
            }
            @media screen and (max-width: 415px) {
                padding-top: 81px;
            }
        }
    }
    #golden-alpha-otc {
        position: relative;
        background-color: transparent;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        &.show_landing {
            overflow: hidden;
            width: 100vw;
            height: 100vh;
        }
        @media screen and (max-width: 650px) {
            width: 100vw;
        }
        &.dialog {
            height: 100vh;
            overflow: hidden;
            width: 100vw;
        }
        .golden-alpha-otc-body {
            width: 100%;
            &.show_landing {
                display: none;
            }
            @media screen and (max-width: 650px) {
                width: 100vw;
            }
        }
        // .home {
        //     height: 100vh;
        //     width: 50vw;
        // }
        .user-dash {
            width: 1440px;
            max-width: 100%;
        }
        .otc-nav  {
            overflow-y: auto;
            position: fixed;
            &.home {
                padding-bottom: 0px;
                &:not(.ant-layout-sider-collapsed) {
                    width: 50vw !important;
                    max-width: 100vw !important; 
                    flex: 1 !important; 
                    .ant-layout-sider-trigger {
                        display: none;
                    }
                }
            }
            &.ant-layout-sider-has-trigger {
                padding-bottom: 0px;
            }
            &.ant-layout-sider-collapsed {
                .header-content {
                    display: flex;
                    align-items: flex-end;
                    flex-direction: column;
                    flex-wrap: nowrap;
                    justify-content: flex-start;
                    .header-logo {
                        font-size: 9px;
                        padding: 3em 1em;
                        justify-content: flex-start;
                        align-items: flex-end;
                        flex-direction: column;
                        align-content: flex-start;
                        flex: none;
                    }
                }
            }
            .ant-layout-sider-trigger {
                background: rgba(0,0,0, 0.1);
                color: #333;
                // width: 100% !important;    
                // position: absolute;
            }
        }
    }
    .ant-table-content {
        table {
            .ant-table-thead {
                tr {
                    th {
                        background: #FFF;
                        font-weight: 800;
                        border-bottom: none;
                    }
                }
            }
            .ant-table-tbody {
                tr {
                    td {
                        border-bottom: none;
                        overflow: initial;
                        &.ant-table-row-cell-ellipsis {
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                    }
                }
            }
        }
    }
}
.ant-modal {
    scroll-behavior: smooth;
    font-family: var(--font-primary-body);
}
.full-modal {
    background-color: transparent;
    &.kyc-modal {
        .ant-modal-body {
            display: flex;
            align-items: flex-start;
            
        }
    }
    .ant-modal {
        max-width: 100%;
        top: 0;
        padding-bottom: 0;
        margin: 0;
    }
    .ant-modal-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        align-content: center;
        height: 100vh;
        border-radius: 0px;
        background: rgba(0, 0, 0, 0.7);
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        // .ant-modal-header {
        //     .ant-modal-title {
        //         text-transform: capitalize;
        //     }
        // }
    }
    .ant-modal-body {
        // flex: 1;
        overflow: auto;
        padding: 2em;
        max-width: 100%;
        @media screen and (max-width: 910px) {
            padding: 1em;
        }
        .back {
            background-color: #FFF;
            border-radius: 8px;
            border: 1px solid rgba(0, 0, 0, 0.3);
            margin-bottom: 16px;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.slide-left-enter-active,
.slide-left-leave-active {
    transition: 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transform: scale(1) translateX(0);
    opacity: 1;
    // .step {
    //     animation-delay: 10s;
    //     transform: scale(1) translateX(0);
    //     opacity: 1;
    // }
}

.slide-left-enter-from,
.slide-left-leave-to {
    opacity: 0;
    transform: scale(0.98) translateX(16px);
    // .step {
    //     animation-delay: 10s;
    //     transform: scale(0.98) translateX(16px);
    //     opacity: 0;
    // }
}
.slide-down-enter-active,
.slide-down-leave-active {
    transition: 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transform: translateY(0);
    opacity: 1;
}

.slide-down-enter-from,
.slide-down-leave-to {
    opacity: 0;
    transform: translateY(-16px);
}

.slide-up-enter-active,
.slide-up-leave-active {
    transition: 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transform: translateY(0);
    opacity: 1;
}

.slide-up-enter-from,
.slide-up-leave-to {
    opacity: 0;
    transform: translateY(16px);
}

.fade-landing-container-enter-active {
    transition:none ;
}
.fade-landing-container-leave-active {
    transition: 0.8s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition-delay: 1.1s;
}

.fade-landing-container-enter-from {
    opacity: 1;
}
.fade-landing-container-leave-to {
    opacity: 0;
    transition-delay: 0.3s;
}

.fade-landing-enter-active{
    transition: 0.8s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition-delay: 0.5s;
}

.fade-landing-leave-active {
    transition: 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition-delay: 0.4s;
}

.fade-landing-enter-from{
    opacity: 0;
    transition-delay: 0.5s;
}
.fade-landing-leave-to {
    opacity: 0;
    transition-delay: 0.4s;
}

.slide-down-landing-enter-active{
    transition: 1s cubic-bezier(0.645, 0.045, 0.355, 1);
    transform: translateY(0);
    transition-delay: 1.4s;
    opacity: 1;
}
.slide-down-landing-leave-active {
    transition: 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
    transform: translateY(0);
    opacity: 1;
}

.slide-down-landing-enter-from{
    opacity: 0;
    transition-delay: 1.4s;
    transform: translateY(32px);
}
.slide-down-landing-leave-to {
    opacity: 0;
    transform: translateY(-32px);
}

.slide-up-landing-enter-active {
    transition: 1s cubic-bezier(0.645, 0.045, 0.355, 1);
    transform: translateY(0);
    opacity: 1;
    transition-delay: 1.4s;
}
.slide-up-landing-leave-active {
    transition: 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
    transform: translateY(0);
    opacity: 1;
}

.slide-up-landing-enter-from{
    opacity: 0;
    transition-delay: 1.4s;
    transform: translateY(-32px);
}
.slide-up-landing-leave-to {
    opacity: 0;
    transform: translateY(32px);
}
.layered-box {
    box-shadow:
      0 1px 1px hsl(0deg 0% 0% / 0.075),
      0 2px 2px hsl(0deg 0% 0% / 0.075),
      0 4px 4px hsl(0deg 0% 0% / 0.075),
      0 8px 8px hsl(0deg 0% 0% / 0.075),
      0 16px 16px hsl(0deg 0% 0% / 0.075)
    ;
}
.ant-drawer {
    .ant-drawer-mask {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 16px;
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        border: 1px solid rgba(255, 255, 255, 0.3);
    }
}
.ant-popover {
    z-index: 99999;
}
.ant-notification-notice{
    &.otcpro-error-notification {
        background-color: #ae190b;
        color: #FFF;
        .ant-notification-notice-content {
            .ant-notification-notice-message {
                color: rgba(255,255,255,0.4);
                font-size: 0.9em;
            }
        }
    }
    &.otcpro-success-notification {
        background-color: #006800;
        color: #FFF;
        .ant-notification-notice-content {
            .anticon.ant-notification-notice-icon-success {
                color: #FFF;
                font-size: 36px;
                margin-left: 0px;
            }
            .ant-notification-notice-message {
                color: rgba(255,255,255,0.4);
                font-size: 0.9em;
                
            }
        }
    }
}
</style>
<!-- 手机端：输入框 16px 避免 iOS 聚焦时自动放大且失焦后不还原，导致页面“变大”需手动缩小 -->
<!-- 覆盖：1）主内容区 .site-body 2）弹窗 .ant-modal-wrap 3）抽屉 .ant-drawer-body -->
<style lang="less">
@media screen and (max-width: 910px) {
    .site-body,
    .ant-modal-wrap,
    .ant-drawer-body {
        .ant-input,
        .ant-input-number .ant-input-number-input,
        .ant-input-number-input,
        .ant-select .ant-select-selection-search-input,
        textarea.ant-input {
            font-size: 16px !important;
        }
    }
}
</style>
